
enum RatesType {
    PUBLIC = 'PUBLIC', MEMBER = 'MEMBER'
}

export default RatesType;